// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__oJYya","errorLogs":"styles_errorLogs__2pzyI"};